export const FOCUS_PAGER_PROGRESS_EVENT = "focusPagerProgress";

const clamp01 = (value) => {
  const numeric = Number(value);

  if (!Number.isFinite(numeric)) return 0;

  return Math.max(0, Math.min(numeric, 1));
};

export const dispatchFocusPagerProgress = ({
  fromSource,
  toSource,
  progress,
}) => {
  if (
    typeof window === "undefined" ||
    !fromSource ||
    !toSource
  ) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(FOCUS_PAGER_PROGRESS_EVENT, {
      detail: {
        fromSource,
        toSource,
        progress: clamp01(progress),
      },
    })
  );
};

export const dispatchFocusPagerPosition = (
  visualPosition,
  loopedSources
) => {
  if (!Array.isArray(loopedSources) || loopedSources.length === 0) {
    return;
  }

  const maxIndex = loopedSources.length - 1;
  const numericPosition = Number(visualPosition);
  const safePosition = Number.isFinite(numericPosition)
    ? Math.max(0, Math.min(numericPosition, maxIndex))
    : 0;

  const lowerIndex = Math.floor(safePosition);
  const upperIndex = Math.ceil(safePosition);
  const fromSource = loopedSources[lowerIndex];
  const toSource = loopedSources[upperIndex] || fromSource;

  dispatchFocusPagerProgress({
    fromSource,
    toSource,
    progress: safePosition - lowerIndex,
  });
};
